<div>
  <nestas-toolbar></nestas-toolbar>
</div>

<!--<div class="tuto_button_container">
  <a href="https://www.youtube.com/playlist?list=PLN_X58kxNx_rhv65wlepePvDTJ_EtbXi2" target="_blank">
    <button mat-button class="tuto_button">{{translate.instant('BUTTON.ACTION.START_USING_NESTAS_WEB')}}</button>
  </a>
  <button mat-button class="tuto_button"
    (click)="setOption('manual')">{{translate.instant('BUTTON.ACTION.MANUAL')}}</button>
  <button mat-button class="tuto_button"
    (click)="setOption('tuto_mobile')">{{translate.instant('BUTTON.ACTION.START_USING_NESTAS_MOBILE')}}</button>
</div>-->

<modal-frame *ngIf="tuto.option && tuto.option == 'start'" [option]="'start'" (closeModal)="setOption()"></modal-frame>
<modal-frame *ngIf="tuto.option && tuto.option == 'manual'" [option]="'manual'" (closeModal)="setOption()">
</modal-frame>
<modal-frame *ngIf="tuto.option && tuto.option == 'tuto_mobile'" [option]="'tuto_mobile'" (closeModal)="setOption()">
</modal-frame>

<div class="wrap" style="margin-top:0px;">

  <div style="margin-top: -80px; width: 100%; margin-bottom:40px;" class="home">

    <div style="width:100%; overflow: hidden; margin-top:20px;">

      <div class="add-button-wrapper">

        <a (click)="addPID()" [title]="canAddPID() ? '' : translate.instant('MESSAGE.PID_LIMIT_REACHED')"
          class="add-button-home">{{translate.instant('PID.NEW')}}
          <i class="material-icons">add</i>
        </a>

      </div>

      <div class="divsearchbar">
        <nestas-searchbar (search)="filterPID($event)" class="flexbox wrap-search small"></nestas-searchbar>
      </div>

      <div class="tabselectoricons">
        <a (click)="SwitchTab(0)"><img class="cards" src="/assets/iconsicon.png" height="30" style="z-index:1">
        </a>
        <a *ngIf="!isPhone" (click)="SwitchTab(1)">
          <img class="list" src="/assets/listicon2.png" height="30" style="z-index:1">
        </a>
        <div class="mobileonly sortfilt" [ngStyle]="{'opacity' : (tabindex) ? 0.5 : 1}">
          <span>
            <a (click)="filterOnOff()">{{translate.instant('BUTTON.ACTION.FILTER')}}</a>
            <!--<a (click)="tabindex = 1;">sorteren</a>-->
          </span>
        </div>
      </div>

     
    </div>



    <mat-tab-group [@.disabled]="true" #tabGroup class="mat-tab-group home" [(selectedIndex)]="tabindex">
      <mat-tab>
        <!-- PID cards -->
        <div *ngIf="!pids.display.length && !pids.filtered.length" class="default-placeholder">
          <div class="action">{{translate.instant('PLACEHOLDER.NO_PID')}}</div>
          <div>{{translate.instant('PLACEHOLDER.NO_PID_ENTRIES')}}</div>
        </div>

        <div *ngIf="tabindex == 0">


          <div *ngIf="!isPhone" [sortablejs]="pids.filtered" [sortablejsOptions]="sortableOptions">
            <nestas-pid-card *ngFor="let h of pids.filtered" [pid]="h" [pids]="pids.all" editable="true" [picture]="true"
              [reloadHome]="reload"></nestas-pid-card>
          </div>

          <div *ngIf="isPhone">
            <nestas-pid-card *ngFor="let h of pids.filtered" [pid]="h" [pids]="pids.all" editable="true" [picture]="true"
              [reloadHome]="reload"></nestas-pid-card>
          </div>

        </div>
      </mat-tab>

      <mat-tab>
        <!-- PID table -->
        <div *ngIf="!pids.display.length" class="default-placeholder">
          <div class="action">{{translate.instant('PLACEHOLDER.NO_PID')}}</div>
          <div>{{translate.instant('PLACEHOLDER.NO_PID_ENTRIES')}}</div>
        </div>

        <nestas-pid-table *ngIf="tabindex == 1" #pidTable style="margin-top: 20px" [pids]="pids" editable="true"
          [reloadHome]="reload" [events]="eventsSubject.asObservable()">
        </nestas-pid-table>

      </mat-tab>
    </mat-tab-group>
  </div>

  <fsmodal [show]="modal.newPID" [closable]=true (closed)="modal.newPID = false;">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.NEW_PID')}}</div>
    <div class="modal-body-content">
      <div>
        <nestas-toolbar [modal]="modal"></nestas-toolbar>
      </div>

      <div class="wrap">
        <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="pid"></nestas-pidinfo>

        <new-pid #newPID *ngIf="modal.newPID" [pids]="pids.all" [parentPID]="null" (cancelled)="modal.newPID = false;"></new-pid>

        <div style="margin-top:40px; margin-bottom:120px;">
          <button mat-stroked-button (click)="modal.newPID = false">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
          <button mat-raised-button (click)="createPID()" color="primary">
            {{translate.instant('BUTTON.ACTION.SAVE')}}
          </button>
        </div>
      </div>
    </div>
  </fsmodal>


  <modal [show]="modal.agreeToTerms">
    <div class="modal-title-content">{{translate.instant('MODAL.TITLE.TERMS_AND_CONDITIONS')}}</div>
    <div class="modal-body-content">
      {{translate.instant('TERMS_AND_CONDITIONS.CONTENT')}}
    </div>
    <div class="modal-footer-content">
      <button mat-raised-button (click)="agreeToTerms()" color="primary">{{translate.instant('BUTTON.ACTION.AGREE')}}
      </button>
    </div>
  </modal>